import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from '@lingoda/hooks';
import { useIsFFreeTrial } from '@lingoda/f-free-trial';
import { studentPreferencesSelector, studentSelector, updatePreferences } from '@lingoda/students';
import { DialogComponent, showDialog } from '@lingoda/dialogs';

const WelcomeDialogTriggerBase = () => {
    const dispatch = useDispatch();
    const isFFreeTrial = useIsFFreeTrial();
    const student = useSelector(studentSelector);
    const isOnboarded = student?.onboarded;

    const onDismiss = useCallback(() => {
        dispatch(updatePreferences({ dismissedWidgets: { fftWelcomeBanner: true } }));
    }, [dispatch]);

    useEffect(() => {
        if (isOnboarded && isFFreeTrial) {
            dispatch(
                showDialog(DialogComponent.FFreeTrialWelcomeDialog, {
                    onDismiss,
                }),
            );
        }
    }, [dispatch, isOnboarded, onDismiss, isFFreeTrial]);

    return null;
};

export const WelcomeDialogTrigger = () => {
    const studentPreferences = useSelector(studentPreferencesSelector);
    const isDismissed = studentPreferences?.dismissedWidgets?.fftWelcomeBanner === true;

    if (isDismissed) {
        return null;
    }

    return <WelcomeDialogTriggerBase />;
};
